import { FETCH_ME } from '../actions/userActions';
import { UserDataType } from '../types';

export type UserReducerActionType = {
  type: string;
  payload: UserDataType;
};

const userReducer = (state = null, action: UserReducerActionType) => {
  switch (action.type) {
    case FETCH_ME:
      return action.payload;
    default:
      return state;
  }
};

export default userReducer;
